import { DataTypes } from '@hooks/use-remote-config/types';

export enum RemoteConfigActionsEnum {
  SET_DATA = '@remoteConfig/SET_DATA',
}

export type RemoteConfigState = { data: DataTypes };
